var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "language-switcher-sidebar" },
    [
      _c("simple-list", {
        ref: "languageList",
        staticClass: "req",
        attrs: {
          id: "languageList",
          "server-items": _vm.languageOptions,
          variant: "currency-list",
          "internal-scroll": "",
          "single-panel": "",
          height: _vm.listHeight,
        },
        on: {
          "item-update": function ($event) {
            return _vm.$emit("get-focusable-elements")
          },
          mounted: function ($event) {
            return _vm.$emit("update-focusable")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "filter",
            fn: function () {
              return [
                _c(
                  "div",
                  { ref: "header", staticClass: "language-switcher-header" },
                  [
                    _c("header-close", { attrs: { deactivate: _vm.close } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "language-switcher-search-bar form" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "language-switcher-search-bar__input input",
                          },
                          [
                            _c("input", {
                              staticClass: "search-input icon-search",
                              class: [{ "have-value": !!_vm.inputString }],
                              attrs: {
                                id: "languageSearch",
                                type: "text",
                                "data-field-type": "SingleLineText",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.filterItems(
                                    $event.currentTarget.value,
                                    "input"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "floating search-label",
                                attrs: { for: "languageSearch" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.tc("formFields.preferredLanguage")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "rendered-list",
            fn: function (ref) {
              var items = ref.items
              return [
                _c(
                  "ul",
                  _vm._l(items, function (item) {
                    return _c(
                      "li",
                      { key: item.displayName },
                      [
                        _c("language-switcher-card", {
                          attrs: {
                            item: item,
                            "search-input": _vm.inputString,
                            "query-changed": _vm.queryChanged,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }